<template>
  <span id="test123">
    <v-dialog max-width="500px" persistent :value="true">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("travelService.orderAnotherService") }}</span>
        </v-card-title>
        <v-card-text>
          <v-form lazy-validation ref="form" v-model="formValid">
            <fieldset class="custom-fieldset">
              <order-user-select :value.sync="contextModel.travelServiceOrderItemPassengers[0]" />
            </fieldset>
            <v-text-field
              :label="$t('travelService.otherServiceType') + '*'"
              :placeholder="$t('travelService.otherServiceTypeExamples')"
              :rules="[v => (v != null && v.length > 0) || $t('global.error.required')]"
              v-model="contextModel.params"
            />
            <cost-centre-select :value.sync="contextModel.cost_centre" />
            <v-text-field :label="$t('global.comment')" v-model="contextModel.comment" />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="cancel" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
          <v-btn :disabled="!formValid" @click.native="save" color="blue darken-1" text>Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import CostCentreSelect from "./CostCentreSelect";
import OrderUserSelect from "./OrderUserSelect";

export default {
  name: "OrderServiceOther",
  components: { OrderUserSelect, CostCentreSelect },
  data: () => ({
    formValid: true,
    selectedUser: null,
    contextModel: null
  }),
  computed: {
    editedTravelServiceOrderItem() {
      return this.$store.state.TravelService.editedTravelServiceItem;
    }
  },
  watch: {
    contextModel: {
      deep: true,
      handler() {
        if (JSON.stringify(this.contextModel) !== JSON.stringify(this.editedTravelServiceOrderItem)) {
          this.updateVuexState();
        }
      }
    },
    editedTravelServiceOrderItem: {
      deep: true,
      handler(val) {
        this.contextModel = JSON.parse(JSON.stringify(val));
      }
    }
  },
  methods: {
    updateVuexState() {
      this.$store.commit("TravelService/setEditedTravelServiceItem", this.contextModel);
    },
    cancel() {
      this.$store.commit("TravelService/setEditedTravelServiceItem", null);
      this.$store.commit("TravelService/setOldTravelServiceItem", null);
      this.$refs.form.resetValidation();
    },
    save() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("TravelService/saveEditedServiceItem");
      }
    }
  },
  created() {
    this.contextModel = JSON.parse(JSON.stringify(this.editedTravelServiceOrderItem));
  }
};
</script>

<style scoped></style>
